import React, { useEffect, useState, useMemo } from "react";
import {useNavigate} from "react-router-dom";

export default function StatisticsPatientModal({
                                                   data,
                                                   property,
                                                   propertyLabel,
                                                   order,
                                               })
{
    const navigate = useNavigate();
    function getPatientsList() {
        // Expecting `data` to be an array of items shaped like:
        // { surveyOrder: number, patients: { neck: [...], midBack: [...], ... } }
        if (!Array.isArray(data)) return [];

        // Find the entry that matches the requested order
        const entry = data.find((d) => Number(d?.surveyOrder) === Number(order));
        if (!entry || !entry.patients) return [];

        // Access the patients array for the specified property (metric)
        const list = entry.patients?.[property];
        return Array.isArray(list) ? list : [];
    }

    const [patients, setPatients] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    // Keep patients in sync with incoming props
    useEffect(() => {
        setPatients(getPatientsList());
    }, [data, property, order]);

    // Export patients to CSV (two columns: Patient Name, Patient ID)
    function exportPatientsCsv() {
        if (!Array.isArray(patients) || patients.length === 0) return;

        // CSV header
        const headers = ["Patient Name", "Patient Email","Survey Date"];

        // Helper to get display name
        const getName = (p) => (p?.name ?? `${p?.first_name ?? ''} ${p?.last_name ?? ''}`.trim());

        // Basic CSV escaping: wrap in quotes and escape internal quotes
        const esc = (v) => `"${String(v ?? '').replace(/"/g, '""')}"`;

        const rows = [headers.join(',')].concat(
            patients.map(p => [esc(getName(p)), esc(p.email), esc(p.date)].join(','))
        );

        // Prepend BOM for Excel compatibility
        const csvContent = '\uFEFF' + rows.join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `patients-survey-${order}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    }

    return (
        <div>
            <div
                className={"valueSubtitle"}
                onClick={() => setIsOpen(true)}
                style={{
                    marginTop: 0,

                    textDecoration: "underline",
                    cursor:'pointer',
                    paddingTop:'0px',
                    paddingBottom:'10px',
                }}
            >
                {patients.length ? `# of Patients: ${patients.length}` : 'No patients'}
            </div>

            {isOpen && (
                <div
                    role="dialog"
                    aria-modal="true"
                    style={{
                        position: 'fixed',
                        inset: 0,
                        backgroundColor: 'rgba(97, 132, 157, 0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => setIsOpen(false)}
                >
                    <div
                        style={{
                            position:'relative',
                            background: '#fff',
                            padding: '40px',
                            minWidth: '50%',
                            maxWidth: '80%',
                            maxHeight: '70%',
                            overflowY: 'auto',
                            borderRadius: '27px',
                            backgroundColor: 'rgba(238, 251, 255, 1)',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >

                            <h2
                                style={{
                                    color: "rgba(31, 31, 31, 1)",
                                    fontFamily: "HelveticaNeue-Bold",
                                    fontSize: "32px",
                                    fontWeight: 700,
                                    fontStyle: "bold",
                                    textAlign: "center"
                                }}
                            >Patient list</h2>
                            <h3 style={{
                                margin: 0,
                                color: "rgba(97, 132, 157, 1)",
                                fontFamily: "HelveticaNeue-Medium",
                                fontSize: "18px",
                                fontWeight: 500,
                                fontStyle: "medium",
                                textAlign: "center"
                            }}>Survey {order}: {patients?.length ?? 0} patients </h3>
                            <div
                                onClick={() => setIsOpen(false)}
                                style={{
                                    position:'absolute',
                                    top:20,
                                    right:20,
                                    cursor:'pointer',
                                }}
                            >
                                <img className="closeIcon" src="/assets/closeIcon.svg" />
                            </div>

                        <div style={{marginTop: 12}}>
                            {patients.map((p) => (
                                <div onClick={() => navigate("/dashboard/patient/" + p.id)} key={p.id} style={{cursor:'pointer'}}>
                                    {p.name ?? `${p.first_name ?? ''} ${p.last_name ?? ''}`.trim()} ({p.email})
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: 24, display: 'flex', justifyContent: 'center' }}>
                            <button
                                type="button"
                                onClick={exportPatientsCsv}
                                disabled={!patients || patients.length === 0}
                                style={{
                                    padding: '10px 32px',
                                    border: '1px solid rgba(97, 132, 157, 0.6)',
                                    background: patients.length ? 'rgba(97, 132, 157, 1)' : 'rgba(97, 132, 157, 0.3)',
                                    color: '#fff',
                                    cursor: patients.length ? 'pointer' : 'not-allowed',
                                    fontFamily: 'HelveticaNeue-Medium',
                                    fontSize: '16px',
                                    boxShadow: "0 2px 4px 0 rgba(217, 217, 217, 1)",
                                    borderRadius: "23px",
                                    backgroundColor: "rgba(97, 132, 157, 1)"
                                }}
                            >
                                Export Patient List
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
